import { useEffect, useState } from "react";
import { fetchBlogs } from "../services/blogService";
import BlogCard from "./BlogCard";
import PropTypes from "prop-types";

export default function BlogList({ category, author }) {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(6);
  useEffect(() => {
    let isMounted = true;

    const loadBlogs = async () => {
      setLoading(true);
      const data = await fetchBlogs(category);

      if (isMounted) {
        setBlogs(data || []);
        setVisibleCount(6); // ✅ reset on category change
        setLoading(false);
      }
    };

    loadBlogs();

    return () => {
      isMounted = false;
    };
  }, [category]);

  if (loading) {
    return <div className="blog-loading">Loading blogs...</div>;
  }

  if (!blogs.length) {
    return <div className="blog-empty">No blogs found.</div>;
  }
// ✅ Slice blogs
let filteredBlogs = blogs.filter((blog) => {
  
  if (!author) return true;

  const slug = blog.aboutAuthor
    ?.toLowerCase()
    ?.replace(/\s+/g, "-");

  return slug === author;
});
// If no blogs found for author show all blogs
if (author && filteredBlogs.length === 0) {
  filteredBlogs = blogs;
}

const visibleBlogs = filteredBlogs.slice(0, visibleCount);
const hasMoreThanDefault = filteredBlogs.length > 6;
const allBlogsVisible = visibleCount >= filteredBlogs.length;
  return (
      <>
        <div className="blog-grid">
          {visibleBlogs.map((blog) => (
              <BlogCard key={blog.id || blog.title} blog={blog} />
          ))}
        </div>
  {/* ✅ SHOW MORE / SHOW LESS BUTTON */}
        {hasMoreThanDefault && (
            <div className="show-more-wrapper">
              <button
                  className="show-more-btn"
                  onClick={() => {
                    if (allBlogsVisible) {
                      setVisibleCount(6);
                      return;
                    }

                    setVisibleCount((prev) => Math.min(prev + 6, filteredBlogs.length));
                    window.scrollBy({ top: 200, behavior: "smooth" });
                  }}
              >
                {allBlogsVisible ? "Show less" : "Show more"}
              </button>
            </div>
        )}
      </>
  );
}

BlogList.propTypes = {
  category: PropTypes.string.isRequired,
  author: PropTypes.string,
};